// ----------------------------------------------------------------------
// <copyright file="Izenda.SearchCriteria.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');

  var EventUtils = require('EventUtils');
  var classnames = require('classnames');
  var observer = require('mobx-react').observer;
  var connect = require('share/enhancers/Izenda.Connect');
  var actions = require('./Izenda.SearchCriteriaAction');

  var ReportingType = require('./Izenda.ReportingType');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var DropDown = require('share/components/controls/Izenda.DropDown');
  var Button = require('share/components/controls/Izenda.Button');
  var Validator = require('share/components/hoc/Izenda.Validator');
  var DateTimePicker = Validator()(require('share/components/controls/DateTime/Izenda.DateTimePicker'));

  var Select = require('share/components/controls/multiSelectBox/Izenda.Select');
  var CONSTANTS = require('logic/data/Izenda.SchedulingSearchConstants');
  var LicenseCheckerConstants = require('logic/data/Izenda.LicenseCheckerConstants');
  const { remove } = require('lodash/fp');

  var CriteriaMultiSelect = observer(function(props) {
    return (
      <GridLayout.Col cols={3}>
        <GridLayout.Row>
          <GridLayout.Col cols={4} className="u_textRight">
            <label className="control-label">{props.title}</label>
          </GridLayout.Col>
          <GridLayout.Col cols={8}>
            <Select
              multi
              value={props.value}
              options={props.options}
              valueKey="value"
              labelKey="label"
              onChange={handleChangeOption}
            />
          </GridLayout.Col>
        </GridLayout.Row>
      </GridLayout.Col>
    );

    function handleChangeOption(listSelectOption) {
      props.onChange(props.dataKey, listSelectOption);
    }
  });

  var CriteriaOption = observer(function(props) {
    return (
      <GridLayout.Col cols={3}>
        <GridLayout.Row>
          <GridLayout.Col cols={4} className="u_textRight">
            <label className="control-label u_textRight">{props.title}</label>
          </GridLayout.Col>
          <GridLayout.Col cols={8}>
            <DropDown
              value={props.value}
              options={props.options}
              onChange={EventUtils.notifyChange(handleChangeOption, EventUtils.DROPDOWN)}
            />
          </GridLayout.Col>
        </GridLayout.Row>
      </GridLayout.Col>
    );

    function handleChangeOption(newVal) {
      props.onChange(props.dataKey, newVal);
    }
  });

  var DateOption = observer(function(props) {
    var className = classnames({ u_textRight: !props.isToDate, u_textLeft: props.isToDate });
    return (
      <GridLayout.Col cols={3}>
        <GridLayout.Row>
          <GridLayout.Col cols={props.isToDate ? 1 : 4} className={className}>
            <label className="control-label">{props.title}</label>
          </GridLayout.Col>
          <GridLayout.Col cols={8}>
            <DateTimePicker
              value={props.value}
              time={false}
              onChange={handleChange}
              field={props.dataKey}
              onBlur={props.onBlur}
            />
          </GridLayout.Col>
        </GridLayout.Row>
      </GridLayout.Col>
    );

    function handleChange(value) {
      props.onChange(props.dataKey, value);
    }
  });

  var SearchCriteria = function(props) {
    var store = props.store;
    var criteria = store.criteria;
    var recurrenceOptions = criteria.recurrenceOptions;
    var deliveryMethodOptions = criteria.deliveryMethodOptions;
    var createdByOptions = criteria.createdByOptions.peek();
    var recipientsOptions = criteria.recipientsOptions.peek();
    var instanceTypes = CONSTANTS.INSTANCE_TYPE;
    var localization = props.localization;
    var authorization = props.authorization;
    var hasAlertingLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Alerting);

    // Don't show Schechuled Alert & Subscribed Alert if don't have Alerting License
    if (!hasAlertingLicense) {
      instanceTypes = remove({ alertingLicense: true }, instanceTypes);
    }

    return (
      <div className="u_marginBottom u_borderAll">
        <div className="izenda-SearchCriteria-Header u_paddingAll">
          <span className="u_textBold">{localization.getText('SEARCH_RESULT_LABEL_SEARCH_CRITERIA')}</span>
        </div>
        <GridLayout className="izenda-SearchCriteria-Body u_paddingAll form-horizontal">
          <ReportingType criteria={criteria} onAddNewReportName={props.handleAddNewReportName} store={store} />
          <GridLayout.Row>
            <CriteriaMultiSelect
              dataKey="instanceType"
              title={localization.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_INSTANCE_TYPE')}
              value={criteria.getMultiValueCriteria('instanceType')}
              onChange={props.handleChangeMultiValuesCriteria}
              options={instanceTypes}
            />
            <CriteriaMultiSelect
              dataKey="recurrence"
              title={localization.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_RECURRENCE')}
              value={criteria.getMultiValueCriteria('recurrence')}
              onChange={props.handleChangeMultiValuesCriteria}
              options={recurrenceOptions}
            />
            <CriteriaMultiSelect
              dataKey="deliveryType"
              title={localization.getText('COMMON_LABEL_DELIVERY_TYPE')}
              value={criteria.getMultiValueCriteria('deliveryType')}
              onChange={props.handleChangeDeliveryType}
              options={CONSTANTS.DELIVERY_TYPE}
            />
            <CriteriaMultiSelect
              dataKey="deliveryMethod"
              title={localization.getText('COMMON_LABEL_DELIVERY_METHOD')}
              value={criteria.getMultiValueCriteria('deliveryMethod')}
              onChange={props.handleChangeMultiValuesCriteria}
              options={deliveryMethodOptions}
            />
          </GridLayout.Row>

          <GridLayout.Row>
            <CriteriaMultiSelect
              dataKey="exportFileType"
              title={localization.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_EXPORT_FILE_TYPE')}
              value={criteria.getMultiValueCriteria('exportFileType')}
              onChange={props.handleChangeMultiValuesCriteria}
              options={CONSTANTS.EXPORT_FILE_TYPE}
            />
            <CriteriaMultiSelect
              dataKey="createdBy"
              title={localization.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_CREATED_BY')}
              value={criteria.getMultiValueCriteria('createdBy')}
              onChange={props.handleChangeMultiValuesCriteria}
              options={createdByOptions}
            />
            {!criteria.isHiddenRecipients && (
              <CriteriaMultiSelect
                dataKey="recipients"
                title={localization.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_RECIPENT')}
                value={criteria.getMultiValueCriteria('recipients')}
                onChange={props.handleChangeMultiValuesCriteria}
                options={recipientsOptions}
              />
            )}
          </GridLayout.Row>

          <GridLayout.Row>
            <CriteriaOption
              dataKey="lastSuccessfulRun"
              title={localization.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_LAST_SUCCESS_RUN')}
              value={criteria.lastSuccessfulRun}
              onChange={props.handleChangeCriteria}
              options={CONSTANTS.LAST_SUCCESS_RUN}
            />
            <GridLayout.Col cols={3} /> {/* place holder for this grid row*/}
            <CriteriaOption
              dataKey="nextScheduledRun"
              title={localization.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_NEXT_SCHEDULED_RUN')}
              value={criteria.nextScheduledRun}
              onChange={props.handleChangeCriteria}
              options={CONSTANTS.NEXT_SCHEDULED_RUN}
            />
          </GridLayout.Row>

          <GridLayout.Row>
            {criteria.isDateLastSuccessRun ? (
              <DateOption
                dataKey="lastSuccessfulRunFrom"
                title={localization.getText('COMMON_LABEL_FROM')}
                value={criteria.lastSuccessfulRunFrom}
                onChange={props.handleChangeCriteria}
                onBlur={props.validateLastSuccessfulRunDate}
              />
            ) : (
              <GridLayout.Col cols={3} />
            )}
            {criteria.isDateLastSuccessRun ? (
              <DateOption
                isToDate
                dataKey="lastSuccessfulRunTo"
                title={localization.getText('COMMON_LABEL_TO')}
                value={criteria.lastSuccessfulRunTo}
                onChange={props.handleChangeCriteria}
                onBlur={props.validateLastSuccessfulRunDate}
              />
            ) : (
              <GridLayout.Col cols={3} />
            )}
            {criteria.isNextScheduledRun && (
              <DateOption
                dataKey="nextScheduledRunFrom"
                title={localization.getText('COMMON_LABEL_FROM')}
                value={criteria.nextScheduledRunFrom}
                onChange={props.handleChangeCriteria}
                onBlur={props.validateNextScheduledRunDate}
              />
            )}
            {criteria.isNextScheduledRun && (
              <DateOption
                isToDate
                dataKey="nextScheduledRunTo"
                title={localization.getText('COMMON_LABEL_TO')}
                value={criteria.nextScheduledRunTo}
                onChange={props.handleChangeCriteria}
                onBlur={props.validateNextScheduledRunDate}
              />
            )}
          </GridLayout.Row>
        </GridLayout>
        <div className="izenda-SearchCriteria-Footer u_paddingAll u_textRight">
          <Button className="u_marginRight" onClick={props.handleSearch}>
            <span className="icon-search" /> {localization.getText('COMMON_LABEL_SEARCH')}
          </Button>
          <button className="btn btn-default" onClick={props.resetData}>
            <span>{localization.getText('COMMON_LABEL_RESET')}</span>
          </button>
        </div>
      </div>
    );
  };

  module.exports = connect(actions)(SearchCriteria);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/Scheduling/Izenda.SearchCriteria.jsx